module.exports = __webpack_public_path__ + "img/solicitante.0258b5d3.png";